import React from "react";
import { FileText } from "lucide-react";
import { PageHeader } from "@/components/molecules/PageHeader";

export const DocInfoBanner: React.FC = () => {
  return (
    <PageHeader
      icon={FileText}
      title="Documentation"
      description="Generate, view, or edit AI-powered documentation for your Salesforce components."
    />
  );
};
